import Vuex from 'vuex'

import makeGetters from './getters'
import makeActions from './actions'
import makeMutations from './mutations'

/**
 * Model Logic
 * - id is generated by the database, autoincrement
 * - code must be unique, 3 to 30 characters
 * - notes must not be blank
 * Mutation Logic (might change)
 * - id = 0, new entry, ensure code is unique to be inserted into db (post)
 * - id > 0 and code exact match db, edit allowed, code must be unique (post)
 * - id > 0 and 2 character code matching last 2 in db, view mode, do not disclose code (get)
 * - id > 0 and code exact match db, edit mode (get)
*/
const defaultFormFields = {
  // System generated
  id: '',
  // User input
  code: '',
  notes: ''
}

// Form states, structure supports only 1 visible form
const defaultFormStates = {
  isDirty: false,
  isLoading: false,
  mode: 'edit',
  skipConfirmationDirty: false
}

export default function makeStore (Vue, alert, firebase, router, snackbar) {
  const state = {
    ...defaultFormFields,
    ...defaultFormStates,
    formTimestamp: (new Date()).getTime()
  }

  Vue.use(Vuex)

  return new Vuex.Store({
    state,
    actions: makeActions(Vue, alert, firebase, router, snackbar),
    getters: makeGetters(),
    mutations: makeMutations(defaultFormFields, defaultFormStates)
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js